export const POST_USER = "POST_USER";
export const POST_PLAY = "POST_PLAY";
export const RESET_STORE = "RESET_STORE";
export const ERROR_API = "ERROR_API";
export const FETCHING_API = "FETCHING_API";
export const OK_API = "OK_API";
export const RESET_API = "RESET_API";